export default {
    // 通用
    COMMON: 'common-images',
    HOME: 'home-images',
    // 首页 团队
    HOME_SWIPER: 'home-swiper-images',
    // 首页 团队
    HOME_SWIPER_VIDEO: 'home-swiper-videos',
    // 首页 项目
    HOME_PROJECT: 'home-project',
    // 首页 团队
    HOME_TEAM: 'home-team-images',
    // 首页 合作品牌
    HOME_COOPERATE: 'home-cooperate-images',
    // 首页 联系我们
    HOME_CONTACT: 'home-contact-images',
    // 团队 页面
    TEAM: 'team',
    // 联系我们
    CONTACT: 'contact',
    // Who we are
    WWA: 'wwa',
    // 项目 页面
    PRODUCTS: 'products',
    // ART 项目图片
    PROJECTS_IMAGE_ART: 'products-image-art',
    // COM 项目图片
    PROJECTS_IMAGE_COM: 'products-image-com',
    // MULTI 项目图片
    PROJECTS_IMAGE_MULTI: 'products-image-multi',
    // ART 项目 视频
    PROJECTS_VIDEO_ART: 'products-video-art',
    // COM 项目 视频
    PROJECTS_VIDEO_COM: 'products-video-com',
    // MULTI 项目 视频
    PROJECTS_VIDEO_MULTI: 'products-video-multi',

    get(key) {
        const res = localStorage.getItem(key)
        return res && res !== '' ? JSON.parse(res) : []
    },

    getByName(key, name) {
        const res = this.get(key)
        return res ? res.find(item => item.resourceName === name) || {} : {}
    }
}
